import request from '@/util/request';
import qs from 'qs';

export const getPage = (params, options) =>
  request.get('/api/fee/billlist/billPage', Object.assign({}, options, { params }));

export const getAmount = (params, options) =>
  request.get('/api/fee/billlist/billAmount', Object.assign({}, options, { params }));

export const getExcel = (params, options) =>
  request.get('/api/fee/billlist/billExcelPage', Object.assign({}, options, { params }));

export const payBillDiscountsPage = (params, options) =>
  request.get('/api/fee/billlist/payBillDiscountsPage', Object.assign({}, options, { params }));

export const payBillDiscountsAmount = (params, options) =>
  request.get('/api/fee/billlist/payBillDiscountsAmount', Object.assign({}, options, { params }));

export const payBillDiscountsExcel = (params, options) =>
  request.get('/api/fee/billlist/payBillDiscountsExcel', Object.assign({}, options, { params }));
